export type Environment = "tst" | "acc" | "prd" | "dev" | "unknown";

export function deriveEnv(hostname: string): Environment {
  if (hostname.includes(".test.cleverbase.com")) {
    return "tst";
  } else if (hostname.includes(".acc.cleverbase.com")) {
    return "acc";
  } else if (hostname.includes(".cleverbase.com")) {
    return "prd";
  } else if (hostname === "localhost") {
    return "dev";
  } else {
    return "unknown";
  }
}
